<ca-table class="csv-table overflow-auto">
    <thead>
        <tr>
            <th *ngFor="let columnName of columnNames">{{ columnName }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of rows">
            <td *ngFor="let rowItem of row | keyvalue: returnZero">{{ rowItem.value }}</td>
        </tr>
    </tbody>
</ca-table>
<ca-pagination
    class="justify-content-center"
    *ngIf="page.totalElements > 0"
    data-uit="list-pagination"
    class="d-flex justify-content-center"
    [totalSize]="page.totalElements"
    [pageSize]="page.size"
    [currentPage]="page.pageNumber"
    (onPageChange)="setPage(data, $event)"
></ca-pagination>
